import { useEffect } from 'react';

const usePopupClick = (callback: (object: any) => void) => {
  useEffect(() => {
    const handleMouseClick = (evt: MouseEvent) => {
      const { which, clientX, clientY } = evt;
      if (which === 2) {
        callback && callback({ x: clientX, y: clientY });
      }
    };
    document.addEventListener('mousedown', handleMouseClick);
    return () => {
      document.removeEventListener('mousedown', handleMouseClick);
    };
  }, []);
};

export default usePopupClick;
